module.exports = __webpack_public_path__ + "static/media/pin-end.242be990.svg";